const handelPreview = async (file) => {
  const uri = `${process.env.REACT_APP_SERVER}/other/getSigneUrlforRefLinks`;
  try {
    const res = await fetch(uri, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: file }),
    });
    const dataDa = await res.json();
    return dataDa.data;
  } catch (err) {
    console.log(err);
  }
};

module.exports = handelPreview;
